import type {CategoryItem} from '../../../../../hooks/useFilterCategorySelection';
import {normalizeSearchText} from '../../../../../utils/normalizeSearchText';

/**
 * Filters category items by a search term, matching either the category's own
 * label OR any of its child labels, case- and diacritics-insensitively.
 *
 * Contract: `childLabels` are already normalised with `normalizeSearchText` at
 * build time in `buildCategoryItems`, so they are matched bare with `.includes`
 * against the normalised term; the label is normalised here.
 *
 * An empty/falsy term returns the input list unchanged.
 */
export const filterCategoriesBySearch = (items: CategoryItem[], term: string): CategoryItem[] => {
  const normalizedTerm = normalizeSearchText(term);
  if (!normalizedTerm) {
    return items;
  }
  return items.filter(
    (item) =>
      normalizeSearchText(item.label).includes(normalizedTerm) ||
      item.childLabels.some((label) => label.includes(normalizedTerm))
  );
};
